import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { HappyApiStore } from './happy-stores-api.service';

const STORE_DISABLED_MESSAGE = 'This store is currently disabled.';

@Injectable({ providedIn: 'root' })
export class HappyStoreDisabledService {
  private readonly _activeStores: WritableSignal<HappyApiStore[]> = signal([]);
  private readonly _wasRedirected: WritableSignal<boolean> = signal(false);
  private readonly _loaded: WritableSignal<boolean> = signal(false);

  readonly activeStores: Signal<HappyApiStore[]> =
    this._activeStores.asReadonly();
  readonly wasRedirected: Signal<boolean> = this._wasRedirected.asReadonly();
  readonly loaded: Signal<boolean> = this._loaded.asReadonly();

  setActiveStores(stores: HappyApiStore[]): void {
    this._activeStores.set(stores);
    this._loaded.set(true);
  }

  markRedirected(): void {
    this._wasRedirected.set(true);
  }

  isStoreDisabledError(error: unknown): boolean {
    const httpError = error as {
      status?: number;
      error?: { message?: string };
    };

    return (httpError?.error?.message === STORE_DISABLED_MESSAGE);
  }
}
